// Constants
const CONTENTFUL_IMAGES_HOSTNAME = 'images.ctfassets.net';
const HTTPS_PROTOCOL = 'https:';

/**
 * Adds a query parameter to Contentful image URLs
 * @param url - The URL to modify (can be absolute, protocol-relative, or already have query params)
 * @param paramName - The name of the query parameter to add
 * @param paramValue - The value of the query parameter to add
 * @returns The modified URL with the specified parameter added if it's a Contentful image URL
 */
export function addParameterToContentfulUrl(url: string, paramName: string, paramValue: string): string {
  if (!url) return url;

  try {
    // Handle protocol-relative URLs by temporarily adding https:
    const isProtocolRelative = url.startsWith('//');
    const fullUrl = isProtocolRelative ? `${HTTPS_PROTOCOL}${url}` : url;

    // Parse the URL
    const urlObj = new URL(fullUrl);

    // Check if it's a Contentful images URL
    const isContentfulImages = urlObj.hostname === CONTENTFUL_IMAGES_HOSTNAME;

    if (!isContentfulImages) {
      return url; // Return original URL if not Contentful images
    }

    // Add the specified parameter
    urlObj.searchParams.set(paramName, paramValue);

    // Return the modified URL, preserving the original protocol format
    const result = urlObj.toString();
    return isProtocolRelative ? result.replace(HTTPS_PROTOCOL, '') : result;

  } catch (error) {
    // If URL parsing fails, return original URL
    console.warn('Failed to parse URL:', url, error);
    return url;
  }
}
